<template>
  <div class="menu">
    <el-aside :width="menuWidth">
      <el-menu
        router
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        background-color="#305680"
        text-color="#fff"
        active-text-color="#ffd04b"
        style="flex: 1"
      >
        <template v-for="(item, index) in menus">
          <template v-if="!item.hidden">
            <template v-if="item.children && item.children.length > 0 && item.meta.menuShow">
            <el-submenu :index="item.path" :key="index" v-if="!item.hidden">
              <template slot="title">
                <i :class="item.iconClass"></i>
                <span slot="title">{{ item.name }}</span>
              </template>
              <el-menu-item-group
                v-for="(child, index) in item.children"
                :key="index"
              >
                <el-menu-item :index="child.path">
                  <span slot="title">{{ child.name }}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu> 
          </template>
            <template v-else>
              <el-menu-item :index="item.path" :key="index">
                <i :class="item.iconClass"></i>
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </template>
          </template>
        </template>
      </el-menu>
    </el-aside>
  </div>
</template>
<script>
  import eventBus from "@/utils/eventBus";
  import store from "@/store";
  export default {
    data() {
      return {
        menus: [],
        menuWidth: "180px",
      };
    },
    created() {
      this.menus = [...this.$router.options.routes];
    },
    mounted() {
      eventBus.$on("menuShow", this.handleMenuClicked);
    },
    methods: {
      handleMenuClicked(data) {
        this.menuWidth = data ? "180px" : "0px";
      },
    },
  };
</script>
<style lang="scss">
  .menu {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    .el-aside {
      height: 100%;
      transition: width 0.4s ease;
      .el-menu {
        height: 100%;
        i {
          color: #fff;
          margin-right: 15px;
        }
        .el-menu-item {
          text-align: left;
        }
        .el-submenu__title{
          text-align: left;
        }
        .el-submenu .el-menu-item{
          margin-left: 20px;
        }
      }
    }
  }
</style>
